import { render } from "./LessonsAnalytics.vue?vue&type=template&id=a22c291a&scoped=true"
import script from "./LessonsAnalytics.vue?vue&type=script&lang=js"
export * from "./LessonsAnalytics.vue?vue&type=script&lang=js"

import "./LessonsAnalytics.vue?vue&type=style&index=0&id=a22c291a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22c291a"]])

export default __exports__